import React from 'react';
import { object, string } from 'prop-types';
import { intlShape } from 'react-intl';
import classNames from 'classnames';

import config from '../../../../config';
import { formatMoney } from '../../../../util/currency';
import { types as sdkTypes } from '../../../../util/sdkLoader';
import {
  IconBarbecue,
  IconExtraCustom,
  IconSnack,
  IconTowel,
} from '../../../../components/Icons';

import css from './ExtraItem.module.css';

const { Money } = sdkTypes;
const currency = config.currency;

const ExtraItem = (props) => {
  const {
    className,
    extraData,
    intl,
    onClick,
    isSelected
  } = props;
  const { amount, id, information, isByUnit, label } = extraData;
  const classes = classNames(css.root, className);
  const icon = (classname) => {
    switch (id) {
      case 'barbecueFee':
        return <IconBarbecue className={classname} />
      case 'towel':
        return <IconTowel className={classname} />
      case 'snack':
        return <IconSnack className={classname} />

      default:
        return <IconExtraCustom className={classname} />
    }
  }

  return (
    <div className={classes}>
      <div className={isSelected ? css.iconContainerSelected : css.iconContainer}>
        {icon(isSelected ? css.iconSelected : css.icon)}
      </div>
    </div>
  )
}

ExtraItem.defaultProps = {
  className: null,
};

ExtraItem.propTypes = {
  className: string,
  extraData: object.isRequired,
  intl: intlShape.isRequired,
};

export default ExtraItem;
